export default "__VITE_ASSET__4qnwACRa__"